import {emailOTPClient} from 'better-auth/client/plugins';
import {createAuthClient} from 'better-auth/react'; // make sure to import from better-auth/react

const authClient = createAuthClient({
  plugins: [emailOTPClient()],
});
export const {signIn, signOut, signUp, emailOtp} = authClient;

export function useSession() {
  const session = authClient.useSession();

  return {
    ...session,
    isAuthenticated: session.data !== null,
  };
}
